import { databaseRows } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function Database() {
  return (
    <section id="database" className="border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="手办资料库"
          title="12.8 万+ 条目，参数与评分一目了然"
          desc="厂商、系列、比例、发售时间逐项归档，配合真实投票评分，选款前先看一眼心里就有底。"
          actionLabel="进入资料库"
          actionHref="#database"
        />

        <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
          <div className="hidden items-center gap-4 border-b border-background-200 bg-background-50 px-5 py-3 text-xs font-medium text-foreground-500 lg:grid lg:grid-cols-12">
            <span className="col-span-4">手办名称</span>
            <span className="col-span-2">厂商</span>
            <span className="col-span-2">系列</span>
            <span className="col-span-1">比例</span>
            <span className="col-span-1">发售</span>
            <span className="col-span-2 text-right">玩家评分</span>
          </div>

          <ul className="divide-y divide-background-200">
            {databaseRows.map((row) => (
              <li key={row.id}>
                <a
                  href="#database"
                  className="grid grid-cols-2 gap-x-4 gap-y-2 px-5 py-4 transition-colors hover:bg-background-100 lg:grid-cols-12 lg:items-center"
                >
                  <div className="col-span-2 flex items-center gap-3 lg:col-span-4">
                    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-primary-50 text-primary-600">
                      <i className="ri-box-3-line" />
                    </span>
                    <span className="font-heading text-sm font-bold text-foreground-950">
                      {row.name}
                    </span>
                  </div>

                  <div className="flex flex-col lg:col-span-2">
                    <span className="text-[11px] text-foreground-400 lg:hidden">厂商</span>
                    <span className="text-sm text-foreground-700">{row.brand}</span>
                  </div>

                  <div className="flex flex-col lg:col-span-2">
                    <span className="text-[11px] text-foreground-400 lg:hidden">系列</span>
                    <span className="text-sm text-foreground-700">{row.series}</span>
                  </div>

                  <div className="flex flex-col lg:col-span-1">
                    <span className="text-[11px] text-foreground-400 lg:hidden">比例</span>
                    <span className="text-sm text-foreground-700">{row.scale}</span>
                  </div>

                  <div className="flex flex-col lg:col-span-1">
                    <span className="text-[11px] text-foreground-400 lg:hidden">发售</span>
                    <span className="text-sm text-foreground-700">{row.release}</span>
                  </div>

                  <div className="flex items-center justify-between lg:col-span-2 lg:justify-end lg:gap-3">
                    <span className="text-[11px] text-foreground-400 lg:hidden">玩家评分</span>
                    <span className="flex items-center gap-1.5">
                      <span className="font-heading text-base font-bold text-accent-700">
                        {row.score}
                      </span>
                      <span className="text-xs text-foreground-500">{row.votes} 人评分</span>
                    </span>
                  </div>
                </a>
              </li>
            ))}
          </ul>

          <div className="flex flex-col gap-3 border-t border-background-200 bg-background-50 px-5 py-4 sm:flex-row sm:items-center sm:justify-between">
            <p className="text-xs text-foreground-500">
              本周新增 <strong className="text-primary-700">320</strong> 条条目 · 92 条待审核
            </p>
            <a
              href="#database"
              className="flex items-center gap-1.5 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
            >
              <i className="ri-add-line" />
              提交新品条目
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}